import React, { forwardRef, FC, HTMLProps } from 'react';
import { Box, Typography, TextField } from '@material-ui/core';
import cx from 'classnames';

import { translate } from '../../../../utils/helpers';
import { CustomButton } from '../../../../components/UI/CustomButton';
import CloseIcon from '../../../../assets/icons/CloseIcon';
import useStyles from '../CreateTeamModal/styles';

interface EditTeamModalProps {
  name: string;
  nameErr: string;
  setName: Function;
  onClick: () => void;
  setLeaveModal: Function;
}

const EditTeamModal: FC<EditTeamModalProps> = forwardRef<
  HTMLDivElement,
  EditTeamModalProps & HTMLProps<HTMLDivElement>
>(({ name, nameErr, setName, onClick, setLeaveModal }, ref) => {
  const classes = useStyles();

  return (
    <div ref={ref} className={classes.container}>
      <Box className={classes.modal}>
        <CloseIcon className={classes.modalCloseBtn} onClick={() => setLeaveModal(false)} />
        <Typography variant="h3">{translate('page.account.editTeam')}</Typography>
        <Box className={classes.modalContent}>
          <TextField
            name="teamName"
            variant="outlined"
            label={translate('input.label.teamName')}
            className={classes.formField}
            value={name}
            onChange={(e) => setName(e.target.value)}
            error={!!nameErr}
            helperText={nameErr}
          />
        </Box>
        <Box>
          <CustomButton
            btnClass={cx(classes.cancelBtn, classes.btn)}
            onClick={() => setLeaveModal(false)}
            color="secondary"
          >
            {translate('button.cancel')}
          </CustomButton>
          <CustomButton btnClass={classes.btn} onClick={onClick}>
            {translate('button.save')}
          </CustomButton>
        </Box>
      </Box>
    </div>
  );
});

export default EditTeamModal;
